export default __webpack_public_path__ + "static/media/unicrypt-white.6e770eec.png";